export default __webpack_public_path__ + "images/install3.5c5fefc77587f6c622a7b9a07c83a126.png";